export default [{
  path: '/book/ware',
  name: 'book_ware',
  component: () => import('pages/book/wareDetail'),
  meta: {
    title: '语文教材',
    keepName: 'book_ware',
    fromName: 'book_course'
  }
}, {
  path: '/book/detail',
  name: 'book_detail',
  component: () => import('pages/book/detail'),
  meta: {
    title: '图书详情',
    keepName: 'book_detail',
    fromName: 'book_course'
  }
}, {
  path: '/book/library',
  name: 'book_library',
  component: () => import('pages/book/library'),
  meta: {
    title: '诵读资源',
    keepName: 'book_library',
    fromName: 'book_detail,book_course',
  }
}, {
  path: '/book/course',
  name: 'book_course',
  component: () => import('pages/book/course'),
  meta: {
    title: '课文详情'
  }
}, {
  path: '/book/fav',
  name: 'book_fav',
  component: () => import('pages/book/favList'),
  meta: {
    title: '收藏夹'
  }
}]
